module.exports = [
  {
    url: '/vehicleType/page',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          pn: 1,
          size: 10,
          total: 10086,
          list: [
            {
              id: '828990317788135424',
              name: '小型客车',
              speed: 100,
              need_record: 1,
              create_user_id: '100',
              create_time: '2024-01-30 13:16:25',
              update_time: '2024-01-30 16:13:16',
              show_cargo_type: 1,
              check_overweight: 0,
              need_blind_video: 1,
              need_trailer_registration: 0,
              need_truck_driver_license: 0,
              need_truck_compulsory_insurance: 0,
              need_truck_commercial_insurance: 0,
              deleted: 0,
            },
            {
              id: '222',
              name: '越野车',
              speed: 120,
              need_record: 0,
              create_user_id: '100',
              create_time: '2024-01-30 13:16:25',
              update_time: '2024-01-30 16:13:16',
              show_cargo_type: 0,
              check_overweight: 1,
              need_blind_video: 0,
              need_trailer_registration: 1,
              need_truck_driver_license: 1,
              need_truck_compulsory_insurance: 1,
              need_truck_commercial_insurance: 1,
              deleted: 0,
            },
          ],
        },
      }
    },
  },
  {
    url: '/vehicleType/get',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          id: '828990317788135424',
          name: '小型客车',
          speed: 0,
          need_record: 0,
          create_user_id: '100',
          create_time: '2024-01-30 13:16:25',
          update_time: '2024-01-30 16:13:16',
          deleted: 0,
        },
      }
    },
  },
  {
    url: '/vehicleType/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/vehicleType/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/vehicleType/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
]
